import React from 'react';

// Package total + included misc (pass-through) = Grand Total, one row per option/category.
export const MiscSummaryTable = ({ rows, title = 'Summary', testId = 'misc-summary-table', bare = false }) => {
  if (!rows?.length) return null;
  return (
    <div className={bare ? '' : 'border border-gray-200 rounded-lg overflow-hidden mt-2'} data-testid={testId}>
      {title && <div className="bg-[color-mix(in_srgb,var(--navy)_6%,white)] text-[var(--navy)] px-4 py-1.5 text-xs font-semibold">{title}</div>}
      <div className="overflow-x-auto">
        <table className={bare ? 'w-full text-sm' : 'w-full text-xs'}>
          <thead>
            <tr className="bg-gray-100">
              <th className="border-b p-2 text-left font-semibold">Option / Category</th>
              <th className="border-b p-2 text-right font-semibold">Total Package Amount</th>
              <th className="border-b p-2 text-right font-semibold">Miscellaneous Included</th>
              <th className="border-b p-2 text-right font-semibold bg-[color-mix(in_srgb,var(--navy)_15%,white)] text-[var(--navy)]">Grand Total</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.option} data-testid={`${testId}-row-${r.option}`}>
                <td className="border-b p-2 font-medium">{r.option}</td>
                <td className="border-b p-2 text-right whitespace-nowrap">{r.package}</td>
                <td className="border-b p-2 text-right whitespace-nowrap">{r.misc}</td>
                <td className="border-b p-2 text-right whitespace-nowrap font-bold text-[var(--navy)] bg-[color-mix(in_srgb,var(--navy)_10%,white)]"
                  data-testid={`${testId}-grand-${r.option}`}>{r.grand}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
